import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { Button } from "../components/atoms";
import {
    ContractInfoFormSection,
    EMPTY_CONTRACT_INFO_FORM_VALUE,
    type ContractInfoFormValue,
} from "../components/ContractInfoFormSection";

/**
 * 従業員 - 契約情報（個人）設定ページ（Step 2）
 *
 * UI 本体は ContractInfoFormSection（雇用形態側と共有）に委譲する。
 * 入力値は現状 API には送らず、ページ内のローカル state として保持する。
 */
const WorkRuleFormPage = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id?: string }>();

    const [contractInfo, setContractInfo] = useState<ContractInfoFormValue>(
        EMPTY_CONTRACT_INFO_FORM_VALUE,
    );

    const handleBack = () => {
        navigate(id ? `/employee/info/${id}/edit` : "/employee/info/new");
    };

    const handleCancel = () => {
        navigate("/employee/info");
    };

    const handleNext = () => {
        navigate(id ? `/employee/info/${id}/support` : "/employee/info/new/support");
    };

    return (
        <div className="flex-1 flex flex-col bg-white rounded-lg overflow-hidden">
            <div className="flex-1 overflow-auto p-6">
                <ContractInfoFormSection
                    value={contractInfo}
                    onChange={setContractInfo}
                />
            </div>

            <div className="flex justify-end gap-4 px-6 py-4">
                <Button variant="primary" size="md" onClick={handleBack} className="px-8">
                    1.基本情報の設定に戻る
                </Button>
                <Button variant="outline" size="md" onClick={handleCancel} className="px-8">
                    キャンセル
                </Button>
                <Button variant="primary" size="md" onClick={handleNext} className="px-8">
                    3.応援の設定へ進む
                </Button>
            </div>
        </div>
    );
};

export default WorkRuleFormPage;
